import { render } from "./CardPartner.vue?vue&type=template&id=42e6fd95&ts=true"
import script from "./CardPartner.vue?vue&type=script&lang=ts"
export * from "./CardPartner.vue?vue&type=script&lang=ts"

import "./CardPartner.vue?vue&type=style&index=0&id=42e6fd95&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__